import rules from "@/utils/inputRules";
import {isFalse, isTrue} from "@/utils/service/DocumentGeneration/answers";
import { translation } from "@/utils/service/Translations/translations";
import {PRIVACY_POLICY, TERMS_OF_SERVICE} from "@/utils/service/documents";

export default [
    {
        name: "General Information",
        inputs: [
            {
                label: "Mobile Application name",
                model: "software_name",
                type: "text",
                rules: [rules.required],
            },
            {
                model: "company.name",
                type: "businessName",
                classes: "col-md-6",
                rules: [rules.required],
            },
            {
                model: "company.email",
                type: "email",
                classes: "col-md-6",
                rules: [rules.required],
            },
            {
                model: "company.address",
                type: "address",
                classes: "col-md-6",
                rules: [rules.required],
            },
            {
                label: "Phone number",
                model: "company.phone",
                type: "phone",
                classes: "col-md-6",
                input: {
                    global: false,
                },
            },
        ],
        actions: [
            {
                component: () => import("@/components/Projects/Project/ProjectGeneralInformationUpdateOnDocumentCreate.vue"),
                params: (self) => ({
                    color: "secondaryDark",
                    text: true,
                    class: "th-mr-12",
                    to: {
                        name: "project_index",
                        params: self?.$route.params,
                    },
                }),
                cta: "Edit project information",
            },
        ]
    },
    {
        name: "Licensor",
        alerts: [
            {
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                params: () => ({
                    // title: "Useful information",
                    title:
                        "This Agreement will use the short name of the person or party who is licensing the software application. For example, if the name of your company is \"Termshub group Corporation\", enter \"Termshub\".",
                }),
            }
        ],
        inputs: [
            {
                label: "Who is licensing the App?",
                model: "licensor",
                type: "text",
                rules: [rules.required],
            },
        ],
    },
    {
        name: "App stores",
        inputs: [
            {
                title: "Is your Application available on app stores (e.g. Apple App Store or Google Play Store)?",
                model: "use_app_stores",
                type: "radio",
                default: "true",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
            {
                condition: (model) =>
                    isTrue(model["use_app_stores"]),
                model: "app_stores",
                type: "multiSelect",
                label: "My Application is available on:",
                default: [],
                rules: [rules.required],
                values: {
                    apple_app_store: "Apple App Store",
                    google_play_store: "Google Play Store",
                    microsoft_store: "Microsoft Store",
                    other: "Other",
                },
            },
        ]
    },
    {
        name: "Privacy Policy",
        inputs: [
            {
                title: "Does your software collect personal information from users?",
                model: "privacyPolicy.use",
                type: "radio",
                default: "false",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
            {
                condition: (model) => isTrue(model["privacyPolicy.use"]),
                title: "Please insert the link to your Privacy Policy",
                model: "privacyPolicy.link",
                rules: [rules.url],
                type: "text",
            },
            // {
            //     condition: (model) => isTrue(model["privacyPolicy.use"]),
            //     title: "Please insert the link to your Privacy Policy",
            //     model: "privacyPolicy.link",
            //     type: "projectDocument",
            //     policyType: PRIVACY_POLICY,
            // },
            // {
            //     condition: (model) => isFalse(model["privacyPolicy.use"]),
            //     type: "custom",
            //     component: () =>
            //         import("@/components/DocumentGeneration/Alert.vue"),
            //     input: {
            //         title: `Your Software may automatically collect personal information (e.g. by using cookies and web beacons) about your user's device and about the use of the Software. You also may require users to provide certain information as a condition to downloading, installing, or using the Software or certain of its features or functionality.`,
            //     },
            // },
            // {
            //     condition: (model) => isFalse(model["privacyPolicy.use"]),
            //     model: "privacyPolicy.no_use_create",
            //     type: "projectDocumentCreateSuggest",
            //     policyType: PRIVACY_POLICY,
            // },
        ],
        validate: (model) =>
            isFalse(model["privacyPolicy.use"]) ||
            rules.required(model["privacyPolicy.link"]) ||
            rules.url(model["privacyPolicy.link"]) ||
            true,
    },
    {
        name: "Updates",
        inputs: [
            {
                title: "Do you intend to develop and provide Software updates, which may include upgrades, bug fixes, patches, other error corrections, and/or new features?",
                model: "updates",
                type: "radio",
                default: "true",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
        ]
    },
    {
        name: "Third-Party Materials",
        alerts: [
            {
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                params: () => ({
                    title:
                        "Your Software may display, include, or make available third-party content (including data, information, and other products, services, and/or materials) or provide links to third-party websites or services, including through third-party advertising.",
                }),
            }
        ],
        inputs: [
            {
                title: "Does your Software contain third-party materials or links to third-party websites or services?",
                model: "third_party_materials",
                type: "radio",
                default: "true",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
        ]
    },
    {
        name: "User-Generated Content",
        inputs: [
            {
                title: "Can your user generate, create, send, or post content on or through your Software?",
                model: "user_generated_content",
                type: "radio",
                default: "true",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
        ]
    },
    {
        name: "User Submissions",
        inputs: [
            {
                title: "Can your users provide you with feedback & suggestions for your Software?",
                model: "users_feedback",
                type: "radio",
                default: "true",
                values: {
                    true: "Yes",
                    false: "No",
                },
            },
        ]
    },
    {
        name: "Governing Law",
        alerts: [
            {
                component: () =>
                    import("@/components/DocumentGeneration/Alert.vue"),
                params: () => ({
                    title:
                        "Governing law clause determines what state law will be used to interpret this EULA agreement and on which jurisdiction the enforcement of the agreement will be overseen.\n" +
                        "Enter the state or country (for non-US businesses) in which your company is located, or contact an attorney to select a jurisdiction with favorable laws.",
                }),
            }
        ],
        inputs: [
            {
                title:
                    "Which country's (states) laws will govern this Agreement?",
                tooltip:
                    "The country's laws that will be used to interpret the content in this Agreement.",
                model: "law_country",
                type: "country",
                input: {
                    global: false,
                },
            },
            {
                condition: (model) => model["law_country"] && model["law_country"] === "United States",
                model: "law_country_state",
                type: "state",
                input: (model) => ({
                    country: model["law_country"],
                    global: false,
                }),
            },
        ]
    }
];
